export default __webpack_public_path__ + "5a024bad3ccddd043ba53b53a08f13b5.png";